<template>
  <div class="agreement-page">
    <!-- 顶部标题栏 -->
    <div class="header">
      <i class="el-icon-arrow-left back-btn" @click="goBack"></i>
      <h1 class="title">{{ agreementTitle }}</h1>
    </div>

    <!-- 内容区域 -->
    <div class="content">
      <!-- PDF文件预览 -->
      <iframe
        v-if="fileType === 'pdf'"  
        :src="fileUrl"
        class="agreement-iframe"
      ></iframe>

      <!-- 图片预览 -->
      <div v-else-if="fileType === 'image'" class="image-container">
        <img :src="fileUrl" class="agreement-image" />
      </div>

      <!-- 加载提示 -->
      <div v-else class="loading">
        <i class="el-icon-loading"></i>
        <p>加载中...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreementPage',
  data() {
    return {
      agreementTitle: '',
      fileUrl: '',
      fileType: '',
      agreementFiles: {
        'telecom-fraud': {
          name: '电信网络诈骗犯罪及发送不良信息法律责任风险提示告知书',
          file: '（号卡）电信网络诈骗犯罪及发送不良信息法律责任风险提示告知书.pdf',
          type: 'pdf'
        },
        'account-service': {
          name: '电子渠道开户服务协议',
          file: '（号卡）电子渠道开户服务协议.pdf',
          type: 'pdf'
        },
        'five-ministries': {
          name: '五部委公告',
          file: '（号卡）五部委公告.jpg',
          type: 'image'
        },
        'campus-discount': {
          name: '校园客户新入网优惠协议',
          file: '（号卡）校园客户新入网优惠协议.pdf',
          type: 'pdf'
        },
        'product-sales': {
          name: '中国移动广东公司电子渠道商品销售服务协议',
          file: '（号卡）中国移动广东公司电子渠道商品销售服务协议.pdf',
          type: 'pdf'
        },
        'customer-network': {
          name: '中国移动广东公司客户入网协议',
          file: '（号卡）中国移动广东公司客户入网协议.pdf',
          type: 'pdf'
        },
        'privacy-policy': {
          name: '中国移动广东公司隐私和信息保护政策',
          file: '（号卡）中国移动广东公司隐私和信息保护政策.pdf',
          type: 'pdf'
        },
        'termination': {
          name: '解约条款',
          file: '（号卡存量）解约条款.pdf',
          type: 'pdf'
        },
        'anti-fraud': {
          name: '反诈宣传通告',
          file: '反诈宣传通告.jpg',
          type: 'image'
        }
      }
    }
  },
  created() {
    this.loadAgreement()
  },
  methods: {
    loadAgreement() {
      const type = this.$route.query.type
      const agreement = this.agreementFiles[type]
      
      if (agreement) {
        this.agreementTitle = agreement.name
        this.fileType = agreement.type
        
        // 构建文件URL
        let fileUrl = `/agreements/${agreement.file}`
        
        // 如果是PDF，添加视图参数
        if (agreement.type === 'pdf') {
          fileUrl += '#toolbar=0&navpanes=0&scrollbar=1&view=FitH'
        }
        
        this.fileUrl = fileUrl
      } else {
        this.$message.error('协议文件不存在')
        this.goBack()
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.agreement-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);

  .back-btn {
    font-size: 24px;
    color: #333;
    cursor: pointer;
    padding: 10px;
    margin-left: -10px;
    
    &:active {
      opacity: 0.6;
    }
  }

  .title {
    flex: 1;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin: 0;
    padding: 0 40px 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.content {
  flex: 1;
  margin-top: 50px;
  overflow: hidden;
  width: 100%;
  height: calc(100vh - 50px);
}

.agreement-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.image-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .agreement-image {
    max-width: 100%;
    width: 100%;
    height: auto;
    display: block;
  }
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
  
  i {
    font-size: 40px;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 14px;
  }
}
</style>



